import type { MainColumnAriaRole } from '@ms/yammer-web-core-ui/dist/components/AppLayout';
import type { Context } from 'react';
import { createContext } from 'react';

export interface AppContextOptions {
  readonly mainColumnAriaRole: MainColumnAriaRole;
  readonly enableCollapsiblePanelNav: boolean;
  readonly fullScreenModalDialogMarginTop?: number;
  readonly messagePanelMarginTop?: number;
  readonly disableVideoPlayer: boolean;
  readonly disableLiveEventVideoPlayer: boolean;
  readonly isCached: boolean;
  readonly isCurrentNetworkInMto: boolean;
}

export const defaultOptions: AppContextOptions = {
  mainColumnAriaRole: 'main',
  enableCollapsiblePanelNav: false,
  fullScreenModalDialogMarginTop: undefined,
  messagePanelMarginTop: undefined,
  disableVideoPlayer: false,
  disableLiveEventVideoPlayer: false,
  isCached: false,
  isCurrentNetworkInMto: false,
};

const AppContext: Context<AppContextOptions> = createContext<AppContextOptions>(defaultOptions);

export default AppContext;
